// extracted by mini-css-extract-plugin
module.exports = {"container":"CartBadge_container__157O_","balance":"CartBadge_balance__1Mak-","items":"CartBadge_items__1lQVX"};